import CONSTANTS from '../../constants';

export function member(state = null, action) {
	switch (action.type) {
		case CONSTANTS.ACTIONS.MEMBER.GET.PROFILE:
			return action.member;
		default:
			return state
	}
}